import React from 'react';
import { Collapse, Table } from '../../../../core/components';
import { useTranslation, valueBuilder } from '../../../../core/services';
import { colors, css, fonts, spacing, StyleSheet } from '../../../../../styles';

const COLUMNS = {
    action: 'action',
    data: 'data',
    date: 'date',
    step: 'step'
};

export const AuthOnboardingLogs = ({ company }) => {
    const { t } = useTranslation();

    if (!company.authOnboardingLogs || company.authOnboardingLogs.length === 0) return null;

    const renderStepName = step => t(`companies.authOnboardingLogs.steps.${step}`);

    const renderData = data => {
        if (!data) return null;

        return (
            <div className={css(styles.dataContainer)}>
                {Object.entries(data).map(([key, value]) => {
                    if (key === 'isAuto' && data[key]) {
                        return (
                            <div className={css(styles.dataItem)} key={key}>
                                {t('companies.authOnboardingLogs.isAuto')}
                            </div>
                        );
                    }
                    if (key === 'accountName' && data[key]) {
                        return (
                            <div className={css(styles.dataItem)} key={key + value}>
                                {value}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        );
    };

    const columns = [
        {
            title: t('companies.authOnboardingLogs.step'),
            key: COLUMNS.step,
            dataIndex: COLUMNS.step,
            render: renderStepName
        },
        {
            title: t('companies.authOnboardingLogs.action'),
            key: COLUMNS.action,
            dataIndex: COLUMNS.action
        },
        {
            title: t('companies.authOnboardingLogs.date'),
            key: COLUMNS.date,
            dataIndex: COLUMNS.date,
            render: valueBuilder.getFullTime
        },
        {
            title: t('companies.authOnboardingLogs.data'),
            key: COLUMNS.data,
            dataIndex: COLUMNS.data,
            render: renderData
        }
    ];

    return (
        <Collapse
            data={[
                {
                    title: t('companies.authOnboardingLogs.title'),
                    content: <Table columns={columns} data={company.authOnboardingLogs} />,
                    key: 'authOnboardingLogs'
                }
            ]}
        />
    );
};

const styles = StyleSheet.create({
    dataContainer: {
        display: 'flex',
        gap: spacing.s1
    },
    dataItem: {
        ...fonts.xsNormal,
        padding: spacing.s0,
        color: colors.primary,
        border: `1px solid ${colors.primary}`,
        borderRadius: spacing.s4
    }
});
